import React, { useEffect, useState } from "react";
import { Box, Paper } from "@mui/material";
import TitleWithBack from "../Home/TitleWithBack";
import { useLocation, useNavigate } from "react-router-dom";
import AECustomerDetails from "./AECustomerDetails";
import AEEventTabs from "./AEEventTabs";
import { useDispatch, useSelector } from "react-redux";
import AEButtons from "./AEButtons";
import { resetForm } from "../../Redux/slices/addEnquirySlice";
import { ADD, ROUTE_ALL_ENQUIRIES, ROUTE_ENQUIRY_DETAILS } from "../../Util/VMConstants";
import { isEmpty } from "../../Util/UtilHelper";

function VMAddEnquiry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer = useSelector((state) => state.addEnquiry.customer);
  const location = useLocation();
  const [redirectComp,setRedirectComp] = useState('');

  const enquiry_id = location?.state?.enquiry_id || null;
  const arrived = location?.state?.arrived || null;



  useEffect(() => {
    dispatch(resetForm());
  }, [dispatch]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if(!isEmpty(arrived)){
      if(arrived ===ADD){
        setRedirectComp(ROUTE_ALL_ENQUIRIES);
      }else{
        setRedirectComp(ROUTE_ENQUIRY_DETAILS);
      }
    }
  }, [arrived]);


  return (
    <Paper sx={{ padding: 2 , ml: { md: 5 },mt:3}}>
      <TitleWithBack title="Add Enquiry" 
       onBackClick={() => navigate('/' + redirectComp , { replace: true }) }
      //  onBackClick={() => navigate(-1)}
       />
      <AECustomerDetails enquiry_id={enquiry_id} arrived={arrived}/>
      {customer.enquiry_id && (
        <Box>
          <AEEventTabs enquiry_id={enquiry_id} arrived={arrived}/>
          <AEButtons arrived={arrived} />
        </Box>
      )}
    </Paper>
  );
}

export default VMAddEnquiry;
